<template>
  <van-popup v-model="visible" position="bottom" round :style="{ height: '70%' }">
    <div class="site-list">
      <div class="popup-header">
        <span class="title">全部网点</span>
        <span class="count">共{{ siteList.length }}个</span>
        <van-icon name="cross" size="20" color="#999" @click="close" />
      </div>
      
      <!-- 排序选项 -->
      <div class="sort-bar">
        <div class="sort-item" :class="{ active: sortType === 'distance' }" @click="sortType = 'distance'">
          <span>按距离</span>
        </div>
        <div class="sort-item" :class="{ active: sortType === 'level' }" @click="sortType = 'level'">
          <span>按级别</span>
        </div>
      </div>
      
      <!-- 站点列表 -->
      <div class="list-content">
        <div class="site-card" v-for="site in sortedList" :key="site.id" @click="selectSite(site)">
          <div class="site-info">
            <div class="site-name">
              <span class="level-tag" :class="'level-' + site.areaLevel">{{ getLevelName(site.areaLevel) }}</span>
              <span>{{ site.siteName }}</span>
            </div>
            <div class="site-address">
              <van-icon name="location-o" size="12" />
              <span>{{ site.address }}</span>
            </div>
            <div class="site-time">
              <van-icon name="clock-o" size="12" />
              <span>{{ site.time }}</span>
            </div>
          </div>
          <div class="site-distance">
            <span class="distance">{{ site.distance }}km</span>
            <van-icon name="arrow" size="14" color="#999" />
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Icon } from 'vant';

export default {
  name: 'SiteList',
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon
  },
  props: {
    value: { type: Boolean, default: false },
    siteList: { type: Array, default: () => [] }
  },
  data() {
    return {
      sortType: 'distance'
    };
  },
  computed: {
    visible: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    },
    sortedList() {
      const list = [...this.siteList];
      if (this.sortType === 'distance') {
        return list.sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance));
      } else {
        return list.sort((a, b) => parseInt(a.areaLevel) - parseInt(b.areaLevel));
      }
    }
  },
  methods: {
    close() {
      this.visible = false;
    },
    getLevelName(level) {
      const names = { '1': '市级', '2': '区级', '3': '街道', '4': '社区' };
      return names[level] || '';
    },
    selectSite(site) {
      this.$emit('select', site);
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.site-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
}

.popup-header {
  display: flex;
  align-items: center;
  padding: 16px;
  background: #fff;
  border-bottom: 1px solid #eee;
  
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
  
  .count {
    font-size: 13px;
    color: #999;
    margin-left: 8px;
    flex: 1;
  }
}

.sort-bar {
  display: flex;
  background: #fff;
  padding: 10px 16px;
  gap: 12px;
  
  .sort-item {
    padding: 6px 16px;
    border-radius: 16px;
    background: #f5f5f5;
    font-size: 13px;
    color: #666;
    
    &.active {
      background: #e8f4ff;
      color: #1989fa;
    }
  }
}

.list-content {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  padding-bottom: 30px;
}

.site-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
  
  .site-info {
    flex: 1;
    min-width: 0;
    
    .site-name {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 8px;
      
      > span:last-child {
        font-size: 15px;
        font-weight: 500;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    
    .site-address, .site-time {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 12px;
      color: #999;
      margin-bottom: 4px;
      
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  
  .site-distance {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: 12px;
    
    .distance {
      font-size: 14px;
      color: #1989fa;
      font-weight: 500;
    }
  }
}

.level-tag {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  color: #fff;
  flex-shrink: 0;
  
  &.level-1 { background: #E53935; }
  &.level-2 { background: #1E88E5; }
  &.level-3 { background: #43A047; }
  &.level-4 { background: #FB8C00; }
}
</style>
